<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset, errors}" ref="observer" slim>
    <b-tab :title-link-class="hasErrors(errors) ? 'has-error' : ''">
      <template v-slot:title>
        {{ $t('Auction fields') }}
        <span v-if="hasErrors(errors)" style="width: 20px;height: 20px" id="premium-exclamation-icon">
          <font-awesome-icon class="text-danger hover-cursor" icon="exclamation-circle"/>
        </span>
      </template>

      <div class="row">
        <div class="col-xl-3 col-md-4">
          <input-widget :model="model" attribute="telephone_bid_request_cut_off" type="number" step="1"
                        :append-question="$t('If left empty, corresponding action buttons on the front-end will always remain visible If 0 minutes is entered, corresponding action buttons will disappear exactly at auction start time.')"/>
        </div>

        <div class="col-xl-3 col-md-4">
          <input-widget :model="model" attribute="commission_bid_request_cut_off" type="number" step="1"
                        :append-question="$t('If left empty, corresponding action buttons on the front-end will always remain visible If 0 minutes is entered, corresponding action buttons will disappear exactly at auction start time.')"/>
        </div>

        <div class="col-xl-3 col-md-4">
          <input-widget :model="model" attribute="bidder_registration_cut_off" type="number" step="1"
                        :append-question="$t('If left empty, corresponding action buttons on the front-end will always remain visible If 0 minutes is entered, corresponding action buttons will disappear exactly at auction start time.')"/>
        </div>
      </div>


      <translatable-input-widget :hint="false" :model="model" :fields="model.getTranslatableFieldsArray('ckeditor')"
                                 :errors="errors" v-if="show"/>
      <hr class="mt-0">
    </b-tab>
  </ValidationObserver>
</template>

<script>

  import {createNamespacedHelpers} from "vuex";
  import TranslatableInputWidget from "@/core/widgets/TranslatableInputWidget.vue";
  import InputWidget from "@/core/components/input-widget/InputWidget.vue";

  const {mapState} = createNamespacedHelpers('setup/branch');

  export default {
    name: "AuctionFields",
    components: {InputWidget, TranslatableInputWidget},
    data() {
      return {};
    },
    props: {
      model: {
        type: Object,
        required: true
      },
      show: {
        type: Boolean,
        required: false
      }
    },
    computed: {
      ...mapState(['selectedBranch']),
    },
    methods: {
      hasErrors(errors) {
        for (let i in errors) {
          if (errors[i].length > 0) {
            return true;
          }
        }
        return false;
      }
    }
  }
</script>

<style lang="scss" scoped>
  .footnote-textarea {
    /deep/ textarea {
      resize: none;
      height: 120px;
    }
  }
</style>
